var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Regular",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.25,23.25c-0.2,0-0.389-0.078-0.53-0.22l-10.5-10.5c-0.07-0.07-0.125-0.152-0.163-0.245 c-0.003-0.008-0.007-0.017-0.01-0.026C0.016,12.174,0,12.088,0,12c0-0.089,0.016-0.176,0.048-0.261 c0.002-0.007,0.005-0.014,0.008-0.021c0.04-0.097,0.095-0.179,0.166-0.249L10.72,0.97c0.142-0.142,0.33-0.22,0.53-0.22 s0.389,0.078,0.53,0.22C11.922,1.111,12,1.3,12,1.5s-0.078,0.389-0.22,0.53l-9.22,9.22H23.25c0.414,0,0.75,0.336,0.75,0.75 s-0.336,0.75-0.75,0.75H2.561l9.22,9.22c0.292,0.292,0.292,0.768,0,1.061C11.639,23.172,11.45,23.25,11.25,23.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.80f62baf25140f2ab05f005a31735b99.svg";
export { ForwardRef as ReactComponent };